import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoutubetvComponent } from './simple-icons-youtubetv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoutubetvComponent ],
    exports:      [ SimpleIconsYoutubetvComponent ],
    bootstrap:    []
})
export class SimpleIconsYoutubetvModule {}
